import { createContext, useContext } from "react";

type FolderContextType = {
  folderIds: bigint[];
  currentFolderId?: bigint;
};

const FolderContext = createContext<FolderContextType>({
  folderIds: [],
});

function useFolderContext() {
  return useContext(FolderContext);
}

export { FolderContext, useFolderContext };
